import { buildSlice, CommonState } from '~libs/reduxUtils';

import { SahBudget } from '~support-at-home/models';

import { getAll, getOne, typePrefix, uploadFile } from '~support-at-home/actions/sahBudgets';

interface State extends CommonState<SahBudget> {
  clientRows: SahBudget[];
  // Company-level PRODA connectivity (Decision D), used to gate the rollover / elect-to-return
  // actions in BudgetsModal. It arrives INSIDE `data` on the getOne response, alongside the rows:
  // `data: { budgets, sa_connected }`. The API deliberately does not return it as a top-level
  // sibling of `data`, because anything treating the { success, message, data } envelope as closed
  // drops an unknown sibling silently, which would hide both actions with no error anywhere.
  saConnected: boolean;
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  uploadError: null,
  rows: [],
  clientRows: [],
  saConnected: false,
};

const slice = buildSlice<State, SahBudget>(typePrefix, initialState, {
  extraReducers(builder) {
    builder.addCase(getOne.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      // Defensive against an envelope without `budgets`: `clientRows` feeds `clientBudgets.map()`
      // in BudgetsModal, so an undefined here renders nothing at all rather than an empty table.
      state.clientRows = action.payload?.data?.budgets ?? [];
      state.saConnected = action.payload?.data?.sa_connected === true;
    });
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.uploadError = action.payload as string;
    });
  },
  customActions: {
    clearError(state) {
      state.uploadError = null;
      state.error = null;
    },
  },
  commonConfig: { getAll },
});

export const { clear, clearError } = slice.actions;
export default slice.reducer;
